import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import ScrollToTop from './components/feature/ScrollToTop';
import './i18n';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
